import _ from 'lodash';
window._ = _;

window.addLoadingState = function (loadingContainer, elementsToDisable) {
	loadingContainer.addClass('loading').prepend(`<div class="lds-dual-ring"></div>`);
	if ( elementsToDisable ) {
		elementsToDisable.prop('disabled', true).addClass('disabled');
	}
}

window.removeLoadingState = function (loadingContainer, elementsToEnable) {
	loadingContainer.removeClass('loading').find('.lds-dual-ring').remove();
	if ( elementsToEnable ) {
		elementsToEnable.prop('disabled', false).removeClass('disabled');
	}
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

import Popper from 'popper.js';
window.Popper = Popper.default;

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import 'bootstrap';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if ( token ) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


